import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { FlightListLastPriceChange_flight$key } from '__generated__/FlightListLastPriceChange_flight.graphql';

type Props = {
  flight: FlightListLastPriceChange_flight$key;
};

const today = {
  color: 'error.main',
};

const yesterday = {
  color: 'warning.main',
};

const dayBeforeYesterday = {
  color: 'info.main',
};

const lastWeek = {
  color: 'success.main',
};

const FlightListLastPriceChange: FC<Props> = ({ flight }) => {
  const { lastPriceChange, lastPriceChangeDays, createdAt } = useFragment(
    graphql`
      fragment FlightListLastPriceChange_flight on Flight {
        lastPriceChange
        lastPriceChangeDays
        createdAt
      }
    `,
    flight
  );

  let sx = {};
  let tooltip = 'Kaina nesikeitė mažiausiai 7 dienas';
  let date = lastPriceChange;

  if (lastPriceChangeDays === 0) {
    sx = today;
    tooltip = 'Kaina keitėsi šiandien';
  } else if (lastPriceChangeDays === 1) {
    sx = yesterday;
    tooltip = 'Kaina keitėsi vakar';
  } else if (lastPriceChangeDays === 2) {
    sx = dayBeforeYesterday;
    tooltip = 'Kaina keitėsi užvakar';
  } else if (lastPriceChangeDays <= 7) {
    sx = lastWeek;
    tooltip = 'Kaina keitėsi per paskutines 7 dienas';
  }

  // FIXME: @Cleanup if price haven't changed lastPriceChange should be null instead
  // should be safe to change this once rest api is retired
  if (lastPriceChange === createdAt) {
    sx = {};
    tooltip = 'Kaina nesikeitė';
    date = '---';
  }

  return (
    <Tooltip title={tooltip}>
      <Box sx={sx}>{date}</Box>
    </Tooltip>
  );
};

export default FlightListLastPriceChange;
